export interface SectorEmissions {
  sector: string;
  value: number;
  unit: string;
}

export interface EmissionsByFuel {
  fuel: string;
  value: number;
  unit: string;
}

export interface YearlyEmissions {
  year: number;
  value: number;
  unit: string;
}

export const sectoralEmissionsData: SectorEmissions[] = [
  { sector: "Electricity and Heat", value: 100.65, unit: "million tonnes CO2 equivalent" },
  { sector: "Transport", value: 56.41, unit: "million tonnes CO2 equivalent" },
  { sector: "Manufacturing and Construction", value: 32.01, unit: "million tonnes CO2 equivalent" },
  { sector: "Industry", value: 31.4, unit: "million tonnes CO2 equivalent" },
  { sector: "Waste", value: 29.68, unit: "million tonnes CO2 equivalent" },
  { sector: "Fugitive Emissions", value: 27.3, unit: "million tonnes CO2 equivalent" },
  { sector: "Agriculture", value: 22.26, unit: "million tonnes CO2 equivalent" },
  { sector: "Buildings", value: 17, unit: "million tonnes CO2 equivalent" },
  { sector: "Other Fuel Combustion", value: 2.78, unit: "million tonnes CO2 equivalent" },
  { sector: "Aviation and Shipping", value: 2.67, unit: "million tonnes CO2 equivalent" }
];

// Estimated breakdown of power sector emissions by fuel type
export const powerSectorEmissionsByFuel: EmissionsByFuel[] = [
  { fuel: "Natural Gas", value: 70.46, unit: "million tonnes CO2 equivalent" },
  { fuel: "Oil", value: 25.16, unit: "million tonnes CO2 equivalent" },
  { fuel: "Coal", value: 5.03, unit: "million tonnes CO2 equivalent" }
];

// Estimated historical data for power sector emissions
export const historicalPowerEmissions: YearlyEmissions[] = [
  { year: 2010, value: 65.2, unit: "million tonnes CO2 equivalent" },
  { year: 2011, value: 68.7, unit: "million tonnes CO2 equivalent" },
  { year: 2012, value: 72.3, unit: "million tonnes CO2 equivalent" },
  { year: 2013, value: 75.8, unit: "million tonnes CO2 equivalent" },
  { year: 2014, value: 79.4, unit: "million tonnes CO2 equivalent" },
  { year: 2015, value: 83.1, unit: "million tonnes CO2 equivalent" },
  { year: 2016, value: 86.5, unit: "million tonnes CO2 equivalent" },
  { year: 2017, value: 90.2, unit: "million tonnes CO2 equivalent" },
  { year: 2018, value: 93.8, unit: "million tonnes CO2 equivalent" },
  { year: 2019, value: 96.5, unit: "million tonnes CO2 equivalent" },
  { year: 2020, value: 98.2, unit: "million tonnes CO2 equivalent" },
  { year: 2021, value: 100.65, unit: "million tonnes CO2 equivalent" }
];

// Data source information
export const dataSourceInfo = {
  source: "Our World in Data",
  url: "https://ourworldindata.org/co2/country/egypt",
  accessed: "2025-05-21",
  notes: "Some data points are estimated based on trends and proportions from available data."
};
